import dayjs from 'dayjs';
import { TimeZone } from '../../time/timezone.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ClientInviteComponent extends Component {
  static readonly TYPE_ID: string = 'dff7d59583664f30a3d0a5cf0c52575b';

  constructor(
    public readonly joinDate: dayjs.Dayjs,
    public readonly inviteCodeId: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return ClientInviteComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ClientInviteComponent {
    return new ClientInviteComponent(
        context.decodeDate(MapUtils.get<number>(map, 'joinDate')),
        MapUtils.getOrNull<string>(map, 'inviteCodeId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'joinDate': context.encodeDate(this.joinDate),
      'inviteCodeId': this.inviteCodeId,
    };
  }

  clone(): this {
    return new ClientInviteComponent(
        TimeZone.cloneDate(this.joinDate),
        this.inviteCodeId,
    ) as this;
  }

  isSame(other: ClientInviteComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.joinDate === this.joinDate && other.inviteCodeId === this.inviteCodeId;
  }
}

export class ClientInviteComponentBuilder extends DataModelBuilder<ClientInviteComponent> {
  build(context: SerializationContext, map: SerializedData): ClientInviteComponent {
    return ClientInviteComponent.fromMap(context, map);
  }
}
